<div class="column">
  <div class="font-bold ellipsis">
    <ng-container *ngTemplateOutlet="textWithTooltip; context: { text: fullName }"></ng-container>
  </div>
</div>

<div class="column ellipsis">
  <ng-container *ngTemplateOutlet="textWithTooltip; context: { text: request.job_title }"></ng-container>
</div>

<div class="column ellipsis">
  @if (company$ | async; as company) {
    <div class="cursor-pointer hover:underline ellipsis" (click)="openCompanySidePanel()">
      <ng-container *ngTemplateOutlet="textWithTooltip; context: { text: company.name }"></ng-container>
    </div>
  } @else {
    <ng-container *ngTemplateOutlet="textWithTooltip; context: { text: request.company }"></ng-container>
  }
</div>

<div class="column ellipsis">
  <ng-container *ngTemplateOutlet="textWithTooltip; context: { text: request.email }"></ng-container>
</div>

<div class="column">
  <app-created-source-label [source]="request.created_source"></app-created-source-label>
</div>

<div class="column">
  <div
    class="rounded-full text-white font-bold text-sm py-1 px-4 select-none {{ statusColor }}"
    [ngbTooltip]="
      statusTooltipKey
        | translate: { username: request.approver_or_denier, date: request.status_date | localDate: dateFormat }
    "
    [placement]="'top'"
    [tooltipClass]="'default-tooltip request-tooltip'"
  >
    {{ buildTranslationKey('userStatus.' + request.status) | translate }}
  </div>
</div>

<div class="column">
  @if (request.permission_profile) {
    <app-profile-dropdown [profileId]="request.permission_profile" [readonly]="true"></app-profile-dropdown>
  }
</div>

<div class="column">
  <div class="text-navy-90 text-lg font-normal">
    {{ request.last_login | localDate: dateFormat }}
  </div>
</div>

<div class="column">
  <app-three-dots-menu [menuActions]="menuActions"></app-three-dots-menu>
</div>

<ng-template #textWithTooltip let-text="text">
  <span
    class="whitespace-nowrap truncate min-w-0"
    [ngbTooltip]="text"
    [openTooltipWhenOverflowedAndHovered]="true"
    [openOnWidthOverflow]="true"
    [placement]="'top'"
  >
    {{ text }}
  </span>
</ng-template>

<ng-template #withoutNdaTooltip>
  <span *ngVar="automaticallyApprovedBy$ | async as approvedBy">
    {{
      buildTranslationKey('ndaTooltip.automaticallyApproved')
        | translate
          : {
              username: approvedBy?.username,
              timestamp: approvedBy?.timestamp | localDate: dateFormat,
            }
    }}
  </span>
</ng-template>
